import styled from 'styled-components';
import { rem } from 'polished';
import Button from '@atoms/Button/Button';
import Text from '@atoms/Text/Text';
import variables from '@styles/variables';
import Alert from '@molecules/Alert/Alert';

export const StyledSlotSelector = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 0;
  flex: 1 1 auto;
`;
export const StyledSlotSelectorWrapper = styled.div<{ showFooter: boolean }>`
  display: flex;
  flex-direction: column;
  min-height: 0;
  flex: 1 1 auto;
  margin-bottom: ${rem(-44)};
`;

export const StyledButtonContainer = styled.div`
  margin: 0 ${rem(16)} 0 ${rem(16)};
`;

export const StyledButton = styled(Button)`
  width: 100%;
`;

export const StyledLoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: ${rem(30)};
  padding-bottom: ${rem(30)};
`;

export const StyledLoadingText = styled(Text)`
  margin-bottom: ${rem(12)};
`;

export const StyledSlotFooter = styled.div`
  z-index: 2;
  padding-top: ${rem(16)};
  padding-bottom: ${rem(16)};
  width: calc(100% + ${rem(40)});
  box-shadow: 0 ${rem(-8)} ${rem(20)} 0 rgba(0, 0, 0, 10%);
  background-color: ${variables.colors.white};
  margin-left: ${rem(-20)};
`;

export const StyledAlert = styled(Alert)`
  margin-bottom: ${rem(20)};
  padding: ${rem(12)};
  border-radius: ${rem(4)};
`;
